import React, { Component } from "react";
import screenfull from "screenfull";
import "./App.css";

const gradientSets = [
  { id: "gradient1_momi-spectrum", gradient: "linear-gradient(180deg, #00ee3f, #00c8ff, #ffc000, #ff194f, #ff00ff, #6900d3, #ff0000, #ff9d00, #ffc400, #00ff26, #00ff9d)" },
  { id: "gradient2_cool-blue-green", gradient: "linear-gradient(180deg, #AFFCAF, #12DFF3, #37FF59, #A2F7FF, #2711F2, #AFFCAF, #12DFF3, #37FF59, #A2F7FF, #2711F2)" },
  { id: "gradient3_descending-to-purple", gradient: "linear-gradient(180deg,#F4E8C1, #A0C1B9, #70A0AF, #C3BEF7, #8A4FFF)" },
  { id: "gradient4_pinks-many", gradient: "linear-gradient(180deg, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0)" },
  { id: "gradient5_blue-green", gradient: "linear-gradient(180deg, #AFFCAF, #12DFF3, #37FF59, #A2F7FF)" },
  { id: "gradient6_yellow-greens", gradient: "linear-gradient(180deg, #FFEB33, #37FF59, #2FFF00, #D9FF00, #00FF22)" },
  { id: "gradient7_like-dusk", gradient: "linear-gradient(180deg, #DFF2CB, #F0A13A, #EE609A)" },
  { id: "gradient8_cyan-purple", gradient: "radial-gradient(circle at 40%, #48FFF3, #5DFFAE, #FFBFFE)" },
  { id: "gradient9_high-sat-cyan-orange-magenta", gradient: "linear-gradient(180deg, #3BCFD4, #F20094, #FC9305)" },
  { id: "gradient10_two-blues-horizon", gradient: "radial-gradient(circle at 60% 40%, #0061ff, #00e5ff, #0061ff, #00e5ff, #0061ff, #00e5ff, #0061ff, #00e5ff, #0061ff, #00e5ff)" },
  { id: "gradient11_sunrise-on-the-sun", gradient: "radial-gradient(circle at 60% 40%, #ff930f, #fffcb0, #ff930f, #fffcb0, #ff930f, #fffcb0)" },
  { id: "gradient12_all-brown", gradient: "radial-gradient(circle at 60% 40%, #cb6d02, #351701, #743800)" },
  { id: "gradient13_slate_and_rose", gradient: "radial-gradient(circle at 85% 90%, #177E89, #084C61, #DB3A34, #FFC857, #323031)" },
  { id: "gradient14_terracotta-chlorophyll", gradient: "radial-gradient(circle at 85% 90%, #436436, #D6F599, #D2FF28, #C84C09, #420217)" },
  { id: "gradient15_platinum-blush", gradient: "radial-gradient(circle at 15% 60%, #D8E2DC, #FFE5D9)" },
  { id: "gradient16_lava-float", gradient: "radial-gradient(circle at 60% 40%, #E89005, #EC7505, #D84A05, #F42B03, #E70E02)" },
  { id: "gradient17_coral-emerald", gradient: "linear-gradient(180deg, #EE6055, #FFD97D, #60D394, #AAF683, #FF9B85)" },
  { id: "gradient18_warmer-indigo", gradient: "linear-gradient(60deg, #1023FF, #8A4FFF, #4BB3FD, #0496FF, #1023FF, #8A4FFF, #4BB3FD, #0496FF, #1023FF, #8A4FFF, #4BB3FD, #0496FF)" },
  { id: "gradient19_sunset-with-green", gradient: "linear-gradient(60deg, #5CF64A, #87E752, #43B929, #0496FF, #FFCAE9, #FF37A6)" },
  { id: "gradient20_hotter-pinksphere", gradient: "radial-gradient(circle at 60% 40%, #c0007a, #ff1717, #ff39a3)" },
  { id: "gradient21_sky-without-dust", gradient: "radial-gradient(circle at 60% 40%, #7D83FF, #007FFF, #1AFFD5)" },
  { id: "gradient22_candy-spectrum", gradient: "linear-gradient(180deg, #FF00FF, #FF0055, #FF6B00, #FFD300, #00FF00, #00EFFF, #008CFF)" },
  { id: "gradient23_parrot-feathers", gradient: "linear-gradient(180deg, #F9ED32, #00CFFF, #00FF88, #FF0055)" },
  { id: "gradient24_saturated-summer", gradient: "linear-gradient(180deg, #FF6A00, #FF006E, #F72585, #7209B7, #3F37C9, #4895EF, #4CC9F0, #FF6A00, #FF006E, #F72585, #7209B7, #3F37C9, #4895EF, #4CC9F0)" },
  { id: "gradient25_ultra-neon", gradient: "linear-gradient(180deg, #FF0090, #FF5C00, #FFD800, #00FF2F, #00E0FF, #0047FF)" },
  { id: "gradient26_citrus-blast", gradient: "linear-gradient(180deg, #FFFC00, #FFB000, #FF4D00, #FF0066, #FF00C3)" },
  { id: "gradient27_lime-magenta", gradient: "linear-gradient(180deg, #D1FF00, #7FFF00, #00FF85, #00D9FF, #FF00D4)" },
  { id: "gradient28_hot-pink-aqua", gradient: "radial-gradient(circle at 50% 50%, #FF007F, #FF29E3, #00FFE5, #00F0A4)" },
  { id: "gradient29_peacock-flare", gradient: "radial-gradient(circle at 30% 70%, #05F7A2, #0095FF, #7500FF, #FF00DD, #FF0059)" },
  { id: "gradient30_hyperfruit", gradient: "linear-gradient(180deg, #FF1744, #FF9100, #FFEA00, #00E676, #00B0FF, #D500F9)" },
  { id: "gradient31_sci-fi-glow", gradient: "radial-gradient(circle at 80% 20%, #FF00FF, #00FFFF, #00FF66, #FFFF00, #FF00FF, #00FFFF, #00FF66, #FFFF00)" },
  { id: "gradient32_laser-lime-blood", gradient: "linear-gradient(180deg, #E1FF00, #89FF00, #FF003C, #FF006E)" },
  { id: "gradient33_glowstick-rave", gradient: "radial-gradient(circle at 60% 40%, #00FFD5, #FF00A8, #FFE600, #00FF47)" },
  { id: "gradient34_shocking-aqua-magenta", gradient: "linear-gradient(180deg, #00FFF7, #00C3FF, #F000FF)" },
  { id: "gradient35_alien-dawn", gradient: "radial-gradient(circle at 80% 20%, #B5FF00, #52FF00, #00FFD5, #FF007B)" },
  { id: "gradient36_hyper-orange-violet", gradient: "linear-gradient(180deg, #FF7A00, #FF004D, #7B00FF)" },
  { id: "gradient37_cyberpunk-grid", gradient: "linear-gradient(135deg, #FF00F5, #FF005E, #00FFD9, #00FF90, #00FFE5)" },
  { id: "gradient38_electric-mango", gradient: "radial-gradient(circle at 30% 80%, #FFE600, #FF9100, #FF0073, #FF00D4)" },
  { id: "gradient39_radioactive-watermelon", gradient: "linear-gradient(60deg, #FF005D, #FF008C, #85FF00, #00FF76)" },
  { id: "gradient40_tropical-gamma", gradient: "linear-gradient(180deg, #FFDD00, #FF00C8, #00FFD5, #00FF85, #F700FF)" },
  { id: "gradient41_exploding-nebula", gradient: "radial-gradient(circle at 50% 50%, #FF0D6B, #FF9900, #FFE600, #00FF95, #00E0FF, #B700FF)" },
  { id: "gradient42_midnight-candy", gradient: "linear-gradient(180deg, #0B0033, #1C0066, #5A189A, #FF006E, #0B0033, #1C0066, #5A189A, #FF006E, #0B0033, #1C0066, #5A189A, #FF006E)" },
  { id: "gradient43_blood-and-ember", gradient: "radial-gradient(circle at 70% 30%, #2B0000, #5A0000, #FF4B00, #FFB600)" },
  { id: "gradient44_shadowed-jungle", gradient: "linear-gradient(180deg, #001A00, #003300, #008F11, #A7FF83, #001A00, #003300, #008F11, #A7FF83, #001A00, #003300, #008F11, #A7FF83)" },
  { id: "gradient45_noir-cyan-flash", gradient: "radial-gradient(circle at 40% 70%, #000000, #002233, #005577, #00FFF7)" },
  { id: "gradient46_deep-violet-acid", gradient: "radial-gradient(circle at 50% 50%, #0F001F, #3A0CA3, #7209B7, #FF006E)" },
  { id: "gradient47_industrial-night", gradient: "linear-gradient(180deg, #0A0A0A, #232323, #6B6B6B, #FFD700)" },
  { id: "gradient48_dark-emerald-fire", gradient: "radial-gradient(circle at 20% 80%, #001A14, #004632, #008F66, #FF4000, #001A14, #004632, #008F66, #FF4000, #001A14, #004632, #008F66, #FF4000)" },
];

class App extends Component {
  constructor(props) {
    super(props);

    const calculatedDivs = this.calculateDivCount();
    const selectedGradient = gradientSets[this.getRandomInt(0, gradientSets.length)];
    const selectedImages = this.getUniqueRandomImages(calculatedDivs, 136);

    console.log("Selected Gradient: ", selectedGradient);

    this.state = {
      divs: this.initializeDivs(calculatedDivs, selectedImages),
      selectedGradient,
      selectedImages,
    };

    this.updateIntervals = {};
  }

  componentDidMount() {
    this.startUpdates();
    window.addEventListener("keydown", this.handleKeyPress);
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    Object.values(this.updateIntervals).forEach(clearTimeout);
    window.removeEventListener("keydown", this.handleKeyPress);
    window.removeEventListener("resize", this.handleResize);
  }

  calculateDivCount() {
    const { innerWidth, innerHeight } = window;
    const screenArea = innerWidth * innerHeight;
    const densityDivisor = 72000; // Slightly lower density
    let count = Math.floor(screenArea / densityDivisor);
    const MAX_DIVS = 250;
    return Math.min(count, MAX_DIVS);
  }

  handleResize = () => {
    const newDivCount = this.calculateDivCount();
    Object.values(this.updateIntervals).forEach(clearTimeout);
    this.updateIntervals = {};

    const selectedImages = this.getUniqueRandomImages(newDivCount, 133);
    const newDivs = this.initializeDivs(newDivCount, selectedImages);

    this.setState(
      {
        divs: newDivs,
        selectedImages,
      },
      () => this.startUpdates()
    );
  };

  handleKeyPress = (e) => {
  if (e.key === " ") {
    e.preventDefault(); // stop the page from scrolling
    window.location.reload();
  }
  };


  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  getRandomScale() {
    return Math.random() * (1.2 - 0.1) + 0.1; // ✅ jump between 0.1 and 1.2
  }

  getUniqueRandomImages(count, maxImages) {
    const numbers = new Set();
    while (numbers.size < count) {
      numbers.add(this.getRandomInt(1, maxImages));
    }
    return Array.from(numbers);
  }

  initializeDivs(count, images) {
    return Array.from({ length: count }, () => ({
      currentImage: images[this.getRandomInt(0, images.length)],
      cacheBust: Date.now() + Math.random(), // ✅ unique cache-busting token
      scale: this.getRandomScale(),
      position: this.getRandomPosition(),
    }));
  }

  getRandomPosition() {
    return {
      top: `${this.getRandomInt(-20, 120)}%`,
      left: `${this.getRandomInt(-20, 120)}%`,
    };
  }

  startUpdates() {
    this.state.divs.forEach((_, index) => {
      const updateDiv = () => {
        this.setState((prevState) => {
          if (!prevState.divs[index]) return null;
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            currentImage:
              prevState.selectedImages[
                this.getRandomInt(0, prevState.selectedImages.length)
              ],
            cacheBust: Date.now() + Math.random(), // ✅ regenerate cache-busting value
            scale: this.getRandomScale(),
            position: this.getRandomPosition(),
          };
          return { divs: newDivs };
        });

        this.updateIntervals[index] = setTimeout(
          updateDiv,
          this.getRandomInt(200, 2000)
        );
      };

      this.updateIntervals[index] = setTimeout(
        updateDiv,
        this.getRandomInt(500, 6000)
      );
    });
  }

  goFullScreen = () => {
    const element = document.querySelector(".App");
    if (screenfull.isEnabled && element) {
      screenfull.request(element);
    }
  };

  render() {
  const { selectedGradient, divs } = this.state;

  return (
    <div
      className="App"
      style={{
        background: selectedGradient.gradient,
        backgroundSize: "700% 700%",
        animation: "AnimationName 60s ease infinite",
      }}
    >
      {Array.isArray(divs) &&
        divs.map((div, index) => {
          if (!div) return null;
          return (
            <div
              className="theArt"
              key={index}
              onClick={this.goFullScreen}
              style={{
                position: "absolute",
                top: div.position.top,
                left: div.position.left,
                transform: `translate(-50%, -50%) scale(${div.scale})`,
              }}
            >
              <img
                src={`${require(`./images/${div.currentImage}.gif`)}?v=${div.cacheBust}`}
                alt={`art${index + 1}`}
                onError={(e) => {
                  e.target.onerror = null; // prevent infinite loop
                  e.target.src = require('./images/135.gif'); // fallback image
                }}
              />
            </div>
          );
        })}
      <canvas id="captureCanvas" style={{ display: "none" }}></canvas>
    </div>
  );
}
}

export default App;

